import { useMemo, useReducer, useRef } from 'react';
import { getInitialMediaPlaybackState } from '../utils/getInitialMediaPlaybackState';
import { mediaPlaybackReducer } from '../stores/AudioPlaybackStore';
import { jsx as _jsx } from "react/jsx-runtime";
export const withMediaPlayerDefaults = Component => {
  return props => {
    const mediaProgressBarRef = useRef(null);
    const mediaRef = useRef(null);
    const initialClipStartTimeProxy = useMemo(() => !props.initialClipStartTime || isNaN(props.initialClipStartTime) ? 0 : props.initialClipStartTime, [props.initialClipStartTime]);
    const [mediaState, mediaStateDispatch] = useReducer(mediaPlaybackReducer, getInitialMediaPlaybackState(props.audioDurationInSeconds, props.initialClipEndTime, initialClipStartTimeProxy));
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
      mediaProgressBarRef: mediaProgressBarRef,
      mediaRef: mediaRef,
      mediaState: mediaState,
      mediaStateDispatch: mediaStateDispatch
    }));
  };
};